type IconName = 'pencil' | 'trash' | 'share' | 'play' | 'check' | 'cloudDownload' | 'fork' | 'globe' | 'plus' | 'arrow'

interface IconProps {
  name: IconName
  size?: number
}

const Icon = ({name, size = 14}: IconProps) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }
  switch (name) {
    case 'pencil':
      return (
        <svg {...common}>
          <path d="M3 21l3.5-1 11-11-2.5-2.5L4 17.5 3 21z" />
          <path d="M14 6.5L17.5 10" />
        </svg>
      )
    case 'trash':
      return (
        <svg {...common}>
          <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" />
        </svg>
      )
    case 'share':
      return (
        <svg {...common}>
          <path d="M4 12v7a1 1 0 001 1h14a1 1 0 001-1v-7" />
          <path d="M16 6l-4-4-4 4" />
          <path d="M12 2v14" />
        </svg>
      )
    case 'play':
      return (
        <svg {...common}>
          <polygon points="6 4 20 12 6 20 6 4" fill="currentColor" stroke="none" />
        </svg>
      )
    case 'check':
      return (
        <svg {...common}>
          <path d="M5 12l5 5L20 7" />
        </svg>
      )
    case 'cloudDownload':
      return (
        <svg {...common}>
          <path d="M7 18a5 5 0 01-1-9.9 6 6 0 0111.7 1.4A4.5 4.5 0 0117 18" />
          <path d="M12 11v8" />
          <path d="M8.5 15.5L12 19l3.5-3.5" />
        </svg>
      )
    case 'fork':
      return (
        <svg {...common}>
          <circle cx="6" cy="5" r="2" />
          <circle cx="18" cy="5" r="2" />
          <circle cx="12" cy="19" r="2" />
          <path d="M6 7v2a3 3 0 003 3h6a3 3 0 003-3V7" />
          <path d="M12 12v5" />
        </svg>
      )
    case 'globe':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18" />
        </svg>
      )
    case 'plus':
      return (
        <svg {...common}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      )
    case 'arrow':
      return (
        <svg {...common}>
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      )
    default:
      return null
  }
}

export default Icon
